import { HttpClient } from "@angular/common/http";
import { Injectable, InjectionToken, Inject } from "@angular/core";
import { Observable } from "rxjs";
import { OAuthStorageAdapter } from "@impacgroup/angular-oauth-base";
import { ApiListQueryParameter, BaseDatatableStateSaveMode } from "@impacgroup/angular-baselib";
import { map } from "rxjs/operators";
import { instanceToPlain, plainToInstance } from "class-transformer";
import { StolenCamera } from "../../api-models/StolenCamera";

export interface IStolenCameraConfigService {
    stolenCamerasAPI: string;
    utcDateFormat: string;
    datatableStateSaveMode: BaseDatatableStateSaveMode;
}

export const StolenCameraConfigService = new InjectionToken<IStolenCameraConfigService>("StolenCameraConfig");

@Injectable()
export class StolenCamerasService {
    public UTCDATEFORMAT: string = "";
    public datatableStateSaveMode: BaseDatatableStateSaveMode;

    constructor(@Inject(StolenCameraConfigService) private stolenCameraConfig: IStolenCameraConfigService, private http: HttpClient, private oauthStorageAdapter: OAuthStorageAdapter) {
        this.UTCDATEFORMAT = this.stolenCameraConfig.utcDateFormat;
        this.datatableStateSaveMode = this.stolenCameraConfig.datatableStateSaveMode;
    }

    public list(params: ApiListQueryParameter): Observable<{ list: StolenCamera[]; count: number; total: number }> {
        return this.http
            .get<any>(this.getStolenCamerasServiceUrl(""), {
                headers: this.oauthStorageAdapter.getAuthHeadersJSON(),
                params: params as any,
                observe: "response"
            })
            .pipe(
                map((result) => {
                    let count = result.body.length;
                    let total = result.body.length;
                    try {
                        count = parseInt(result.headers.get("X-Pagination-Count") ?? "0", 10);
                    } catch (e) {}
                    try {
                        total = parseInt(result.headers.get("X-Total-Count") ?? "0", 10);
                    } catch (e) {}

                    return {
                        list: plainToInstance(StolenCamera, result.body as any[]),
                        count: count,
                        total: total
                    };
                })
            );
    }

    public stolenCameraDetail(id: string): Observable<StolenCamera> {
        return this.http
            .get<Object>(this.getStolenCamerasServiceUrl(id), {
                headers: this.oauthStorageAdapter.getAuthHeadersJSON()
            })
            .pipe(map((result) => plainToInstance(StolenCamera, result)));
    }

    public addStolenCamera(stolenCamera: StolenCamera): Observable<StolenCamera> {
        return this.http
            .post<Object>(this.getStolenCamerasServiceUrl(""), instanceToPlain(stolenCamera), {
                headers: this.oauthStorageAdapter.getAuthHeadersJSON()
            })
            .pipe(map((result) => plainToInstance(StolenCamera, result)));
    }

    public updateStolenCamera(stolenCamera: StolenCamera): Observable<StolenCamera> {
        if (!stolenCamera._id) {
            throw new Error("Cannot update object without _id");
        }

        return this.http
            .patch<Object>(this.getStolenCamerasServiceUrl(stolenCamera._id), instanceToPlain(stolenCamera), {
                headers: this.oauthStorageAdapter.getAuthHeadersJSON()
            })
            .pipe(map((result) => plainToInstance(StolenCamera, result)));
    }

    public deleteStolenCamera(id: string): Observable<StolenCamera> {
        return this.http
            .delete<Object>(this.getStolenCamerasServiceUrl(id), {
                headers: this.oauthStorageAdapter.getAuthHeadersJSON()
            })
            .pipe(map((result) => plainToInstance(StolenCamera, result)));
    }

    private getStolenCamerasServiceUrl(postfix: string): string {
        return this.stolenCameraConfig.stolenCamerasAPI + postfix;
    }
}
